import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import { useTrueBizApi } from "../../api";
import { APIMonitorType } from "../../types/APIMonitor";
import { PendingNotificationsCountContext } from "./index";

const RESULTS_PER_PAGE = 15;

export default function MonitoringStatsHeader() {
  const pendingNotificationCount = useContext(PendingNotificationsCountContext);
  const api = useTrueBizApi();
  const [counts, setCounts] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const loadMonitoringStats = async () => {
      try {
        setCounts(
          (
            await api.getMonitoringStats(0, RESULTS_PER_PAGE, [
              APIMonitorType.WebPresence,
              APIMonitorType.WebsiteStatus,
            ])
          ).counts
        );
      } finally {
        setLoading(false);
      }
    };

    loadMonitoringStats();
  }, [api]);

  return (
    <Grid container spacing={4}>
      <Grid item xs={3}>
        <Card>
          <CardContent sx={{ textAlign: "center" }}>
            {loading ? (
              <CircularProgress size={28} sx={{ marginLeft: 1 }} />
            ) : (
              <Typography variant="h1" component="div">
                {pendingNotificationCount || <>&mdash;</>}
              </Typography>
            )}
          </CardContent>
          <CardActions>
            <Typography
              variant="h6"
              fontWeight="fontWeightBold"
              width="100%"
              textAlign="center"
              textTransform="uppercase"
            >
              Pending Notifications
            </Typography>
          </CardActions>
        </Card>
      </Grid>
      <Grid item xs={3}>
        <Card>
          <CardContent sx={{ textAlign: "center" }}>
            {loading ? (
              <CircularProgress size={28} sx={{ marginLeft: 1 }} />
            ) : (
              <Typography variant="h1" component="div">
                {counts.domains}
              </Typography>
            )}
          </CardContent>
          <CardActions>
            <Typography
              variant="h6"
              fontWeight="fontWeightBold"
              width="100%"
              textAlign="center"
              textTransform="uppercase"
            >
              Active Monitors
            </Typography>
          </CardActions>
        </Card>
      </Grid>
    </Grid>
  );
}
